import { useQuery } from "@tanstack/react-query";
import { useAuthenticatedRequest } from "hooks/useRequests";
import { AuctionCategory } from "models/cardIngestion";

const useAuctionCategories = () => {
    const get = useAuthenticatedRequest<AuctionCategory[]>({
        method: "get",
        url: '/card-titling/item-categories'
    });

    return useQuery(["card-titling", "item-categories"], get, {
        suspense: true
    });
};

export const useAuctionSubCategories = (categoryId?: string) => {
    const normalizedId = categoryId?.toLocaleLowerCase();

    const get = useAuthenticatedRequest<string[]>({
        method: "get",
        url: `/card-titling/item-categories/${normalizedId}/sub-categories`
    });

    const enabled = !!normalizedId;
    const query = useQuery(["card-titling", "item-categories", normalizedId], get, {
        suspense: true,
        enabled
    });

    return {
        ...query,
        isLoading: enabled && query.isLoading
    };
}

export default useAuctionCategories;